import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { generatePath, Link } from 'react-router'

import { AutoComplete, Input } from 'antd'
import { useResponsive } from 'antd-style'

import { useSearchLazyQuery } from '../../graphql'
import routes from '../../routes'

const Search: FC = () => {
  const { mobile } = useResponsive()
  const { formatMessage } = useIntl()
  const [query, setQuery] = useState('')
  const [search, { data, loading }] = useSearchLazyQuery({ variables: { query } })
  useEffect(() => {
    if (query) {
      search().then()
    }
  }, [query, search])

  return (
    <AutoComplete
      open={!!data && !!query}
      popupMatchSelectWidth={mobile ? 270 : 288}
      dropdownStyle={{ marginTop: 8 }}
      autoClearSearchValue
      onClear={() => setQuery('')}
      options={[
        {
          label: formatMessage({ id: 'search.riders' }),
          options: data?.search?.riders?.nodes?.map((it) => ({
            value: it.name,
            label: (
              <Link onClickCapture={() => setQuery('')} to={generatePath(routes.rider, { slug: it.slug })}>
                {it.name}
              </Link>
            ),
          })),
        },
        {
          label: formatMessage({ id: 'search.tracks' }),
          options: data?.search?.tracks?.nodes?.map((it) => ({
            value: it.name,
            label: (
              <Link onClickCapture={() => setQuery('')} to={generatePath(routes.track, { slug: it.slug })}>
                {it.name}
              </Link>
            ),
          })),
        },
        {
          label: formatMessage({ id: 'search.articles' }),
          options: data?.search?.articles?.nodes?.map((it) => ({
            value: it.title,
            label: (
              <Link onClickCapture={() => setQuery('')} to={generatePath(routes.article, { slug: it.slug })}>
                {it.title}
              </Link>
            ),
          })),
        },
      ]}
    >
      <Input.Search allowClear value={query} loading={loading} size={mobile ? 'large' : 'middle'} onSearch={setQuery} />
    </AutoComplete>
  )
}

export { Search }
